import { Component } from 'react';
import ShowComponent from '../higher_order_components/ShowComponent';

class LoaderComponent extends Component {
  render() {
    return (
      <div className="loader" />
    );
  }
}

export default ShowComponent(LoaderComponent);
